import { Box } from "@mui/material";
import type { JSX } from "react";

import { FilterSelect } from "./FilterSelect.js";
import { SearchInput } from "./SearchInput.js";

type Option = { value: string; label: string };

/**
 * The admin ticket-list filter bar — full-text search + status / priority /
 * assignee / customer chips. Presentational: the page derives the option lists
 * from its lookup queries and maps changes back onto the URL via `onParam`
 * (and `onSearch` for the search box). Extracted from `TicketListPage.tsx`.
 */
export function TicketFilters({
  q,
  onSearch,
  status,
  statusOptions,
  priority,
  priorityOptions,
  assignee,
  assigneeOptions,
  organization,
  organizationOptions,
  onParam,
}: {
  q: string;
  onSearch: (v: string) => void;
  status: string;
  statusOptions: Option[];
  priority: string;
  priorityOptions: Option[];
  assignee: string;
  assigneeOptions: Option[];
  organization: string;
  organizationOptions: Option[];
  onParam: (key: string, value: string | null) => void;
}): JSX.Element {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 1.5,
        gridTemplateColumns: { md: "1fr auto auto auto auto" },
        alignItems: { md: "center" },
      }}
    >
      <SearchInput
        value={q}
        onCommit={(v) => onSearch(v)}
        placeholder="Search tickets — title, description, ref…"
      />
      <FilterSelect
        value={status}
        onChange={(v) => onParam("status", v || null)}
        placeholder="Status"
        options={statusOptions}
      />
      <FilterSelect
        value={priority}
        onChange={(v) => onParam("priority", v || null)}
        placeholder="Priority"
        options={priorityOptions}
      />
      <FilterSelect
        value={assignee}
        onChange={(v) => onParam("assignee_id", v || null)}
        placeholder="Assignee"
        options={assigneeOptions}
      />
      <FilterSelect
        value={organization}
        onChange={(v) => onParam("organization_id", v || null)}
        placeholder="Customer"
        options={organizationOptions}
      />
    </Box>
  );
}
